import Yup from 'utils/yup'

export const defaultValues = {
  fantasyName: null,
}

export const validationSchema = Yup.object().shape({
  fantasyName: Yup.string().nullable().max(60, 'O nome fantasia deve ter no máximo 60 caracteres'),
})
